export const worksVariety = [
  {
    id: "v-01",
    title: "星光大冒险",
    type: "variety" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["真人秀", "户外", "旅行"],
    director: "节目组",
    actors: ["常驻嘉宾团"],
    duration: "全12期",
    rating: 8.3,
    summary:
      "八位明星踏上一场横跨山川的旅行冒险，在未知挑战与真诚互动中展现最真实的一面。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20group%20of%20cheerful%20celebrities%20hiking%20on%20a%20scenic%20mountain%20trail%20with%20backpacks%2C%20bright%20daylight%2C%20fun%20lively%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v01-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20sweeping%20mountain%20valley%20landscape%20with%20hikers%20on%20a%20winding%20trail%2C%20bright%20colorful%20sky%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v01-backdrop&orientation=landscape",
    tags: ["真人秀", "旅行", "爆笑"],
    hot: true,
    updatedAt: "2024-08-20",
  },
  {
    id: "v-02",
    title: "美食奇遇记",
    type: "variety" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["美食", "纪录片", "人文"],
    director: "节目组",
    actors: ["美食寻访团"],
    duration: "全10期",
    rating: 8.7,
    summary:
      "镜头走进街头巷尾，寻访一道道承载着记忆的家常味道，讲述食物背后普通人的坚守与热爱。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20steaming%20bowl%20of%20local%20street%20food%20on%20a%20rustic%20wooden%20table%2C%20warm%20street%20market%20background%2C%20appetizing%20food%20photography%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v02-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20lively%20street%20food%20market%20alley%20at%20dusk%20with%20steaming%20stalls%20and%20warm%20lanterns%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v02-backdrop&orientation=landscape",
    tags: ["美食", "人文", "治愈"],
    hot: true,
    updatedAt: "2024-09-01",
  },
  {
    id: "v-03",
    title: "歌手对决",
    type: "variety" as const,
    year: 2023,
    region: "中国大陆",
    language: "国语",
    genres: ["音乐", "竞技", "真人秀"],
    director: "节目组",
    actors: ["竞演歌手"],
    duration: "全14期",
    rating: 8.5,
    summary:
      "顶级歌手同台竞演，用一场场震撼的现场舞台重新定义什么是真正的音乐表达。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20pop%20singer%20performing%20on%20a%20dramatic%20concert%20stage%2C%20spotlights%20and%20laser%20beams%2C%20vibrant%20energetic%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v03-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20grand%20concert%20stage%20with%20dramatic%20spotlights%2C%20silhouettes%20of%20a%20large%20audience%2C%20vibrant%20colors%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v03-backdrop&orientation=landscape",
    tags: ["音乐", "现场", "竞技"],
    hot: false,
    updatedAt: "2024-02-15",
  },
  {
    id: "v-04",
    title: "潮流合伙人",
    type: "variety" as const,
    year: 2023,
    region: "中国大陆",
    language: "国语",
    genres: ["时尚", "经营", "真人秀"],
    director: "节目组",
    actors: ["创意团队"],
    duration: "全12期",
    rating: 8.1,
    summary:
      "一群创意人从零打造属于自己的潮流品牌，在选品、设计与经营的真实压力中碰撞火花。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20stylish%20young%20designer%20arranging%20trendy%20clothing%20in%20a%20modern%20boutique%20store%2C%20bright%20minimal%20retail%20space%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v04-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20modern%20minimal%20fashion%20boutique%20interior%20with%20racks%20of%20clothing%20and%20soft%20daylight%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v04-backdrop&orientation=landscape",
    tags: ["时尚", "经营", "创业"],
    hot: false,
    updatedAt: "2024-05-06",
  },
  {
    id: "v-05",
    title: "喜剧之王夜",
    type: "variety" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["喜剧", "脱口秀", "竞技"],
    director: "节目组",
    actors: ["喜剧新人团"],
    duration: "全16期",
    rating: 8.4,
    summary:
      "来自各地的喜剧新人轮番登台，用最接地气的段子调侃生活，把日常的烦恼都变成笑声。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20stand%20up%20comedian%20holding%20a%20microphone%20on%20a%20small%20club%20stage%20with%20a%20glowing%20sign%2C%20warm%20spotlight%2C%20playful%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v05-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=an%20intimate%20comedy%20club%20interior%20with%20a%20small%20stage%20and%20warm%20spotlights%2C%20brick%20walls%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v05-backdrop&orientation=landscape",
    tags: ["喜剧", "脱口秀", "解压"],
    hot: true,
    updatedAt: "2024-07-30",
  },
  {
    id: "v-06",
    title: "极速前进",
    type: "variety" as const,
    year: 2022,
    region: "韩国",
    language: "韩语",
    genres: ["竞技", "旅行", "真人秀"],
    director: "节目组",
    actors: ["素人搭档"],
    duration: "全10期",
    rating: 8.2,
    summary:
      "素人搭档环游世界，在限时任务与体力智力的双重考验中争夺最后的胜利。",
    poster:
      "https://readdy.ai/api/search-image?query=two%20teammates%20sprinting%20through%20a%20busy%20foreign%20city%20street%20with%20a%20map%2C%20dynamic%20motion%2C%20bright%20energetic%20daylight%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v06-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20vibrant%20busy%20foreign%20city%20street%20with%20travelers%20and%20lively%20market%20stalls%2C%20bright%20daylight%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v06-backdrop&orientation=landscape",
    tags: ["竞技", "旅行", "团队"],
    hot: false,
    updatedAt: "2024-03-05",
  },
  {
    id: "v-07",
    title: "自然探索者",
    type: "variety" as const,
    year: 2024,
    region: "英国",
    language: "英语",
    genres: ["纪录片", "自然", "纪实"],
    director: "Natural Unit",
    actors: ["纪录片解说"],
    duration: "全8期",
    rating: 8.9,
    summary:
      "跟随镜头深入地球最隐秘的角落，记录罕见生灵的生存故事与自然环境的壮阔变迁。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20majestic%20wild%20animal%20standing%20in%20a%20vast%20dramatic%20landscape%2C%20golden%20hour%20light%2C%20stunning%20wildlife%20documentary%20look%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v07-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20breathtaking%20natural%20landscape%20at%20golden%20hour%20with%20wildlife%20in%20the%20distance%2C%20epic%20documentary%20view%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v07-backdrop&orientation=landscape",
    tags: ["自然", "纪录片", "震撼"],
    hot: true,
    updatedAt: "2024-09-12",
  },
  {
    id: "v-08",
    title: "我们的乐队",
    type: "variety" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["音乐", "纪实", "真人秀"],
    director: "节目组",
    actors: ["参演乐队"],
    duration: "全12期",
    rating: 8.0,
    summary:
      "六支风格迥异的乐队同住一屋，用真实的排练与创作，记录音乐人追梦路上的酸甜苦辣。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20rock%20band%20performing%20in%20a%20rehearsal%20studio%2C%20dramatic%20lighting%20on%20instruments%2C%20energetic%20youthful%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-v08-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20cozy%20music%20rehearsal%20studio%20with%20instruments%20and%20warm%20moody%20lighting%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-v08-backdrop&orientation=landscape",
    tags: ["音乐", "纪实", "梦想"],
    hot: false,
    updatedAt: "2024-06-14",
  },
];